import Agencies from '../Agencies.vue'

export default [
    {
        path: '/agencies', 
        name: '/agencies', 
        meta: { layout: 'mystagit' },
        component: Agencies,
    }
]